import * as handlePreRegistration from '../utils/handlePreRegistrationApiData'
import { contentActions } from '../actions'
import ValidateFormObject from '../utils/ValidateFormObject'
import contentSchema from '../contentSchema'

const {
  FETCH_CONTENT,
  FETCHING_CONTENT,
  FETCH_CONTENT_ERROR,
  FETCH_CONTENTS,
  FETCHING_CONTENTS,
  FETCH_CONTENTS_ERROR,
  OPEN_MODAL,
  CLOSE_MODAL,
  CHANGE_CONTENT,
  DELETE_CONTENT,
  ADD_CONTENT,
  EDIT_CONTENT,
  FORM_TOUCHED,
  NEW_FORM_CONTENT,
  CONTENT_FORM_ERROR,
  CHANGE_PAGE,
  FETCH_HTML_PREVIEW,
  FETCHING_HTML_PREVIEW,
  CHANGE_PER_PAGE,
  FETCH_HTML_PREVIEW_ERROR,
  CHANGE_ORDER_COLUMN,
  CHANGE_ORDER_DIRECTION,
  FETCHING_LOGS,
  FETCH_LOGS,
  FETCH_LOGS_ERROR,
  OPEN_LOGS_MODAL,
  CLOSE_LOGS_MODAL,
  RESET_STATE,
  REMOVE_CONTENT_DOCUMENT,
  CHANGE_REFERENCE,
  OPEN_EDIT_DOCUMENT_MODAL,
  CLOSE_EDIT_DOCUMENT_MODAL,
  CHANGE_JOB_STATUS,
  CLEAR_BUSCA_PESO
} = contentActions

const initialState = {
  loadingContent: false,
  loadingContents: false,
  loadingHtmlPreview: false,
  fetchContentError: false,
  fetchContentsError: false,
  order: {
    column: 'tipo',
    direction: 1
  },
  contents: [],
  contentsPagination: {
    page: 0,
    rowsPerPage: 50,
    length: 0
  },
  content: {
    titulo: '',
    pesoDA: '',
    idioma: '',
    tipo: '',
    codigo: '',
    codigoProtheus: '',
    descricao: '',
    tituloLivro: '',
    copyrightLivro: '',
    isbn: '',
    edicaoLivro: '',
    tituloSecao: '',
    textoSecao: '',
    tituloCapitulo: '',
    tituloArtigo: '',
    tituloDeT: '',
    idiomaCapitulo: '',
    codigoCapitulo: '',
    codigoArtigo: '',
    codigoDeT: '',
    principioAtivo: '',
    classificacaoTerapeutica: '',
    textoModulo: '',
    tituloModulo: '',
    edicaoCurso: '',
    tituloCurso: '',
    copyrightCurso: '',
    autores: '',
    editores: '',
    palavrasChave: '',
    document: '',
    conteudoHtml: '',
    cursoReferencia: '',
    livroReferencia: '',
    codigoAula: '',
    detalhesAula: '',
    tipoOrigem: '',
    dataAtualizacao: '',
    anoPublicacaoArtigo: '',
    anoPublicacaoDeT: '',
    minutosLeitura: '',
    buscaPalavrasChave: '',
    buscaPeso: ''
  },

  contentFormErrors: {},
  contentFormTouched: false,
  modalOpen: false,
  logs: [],
  loadingLogs: false,
  fetchLogsError: false,
  openLogsModal: false,
  openEditDocumentModal: false,
  jobStatus: ''
}

const ContentValidate = new ValidateFormObject(contentSchema)

const contents = (state = initialState, action = {}) => {
  switch (action.type) {
    case CHANGE_REFERENCE:
      const { refType: type, reference, data } = action

      const contentWithReference = {
        ...state.content,
        ...handlePreRegistration.toContentState({ type, reference, data })
      }

      return {
        ...state,
        content: contentWithReference,
        contentFormErrors: ContentValidate.validate({
          formObject: { ...contentWithReference },
          formSchemaType: contentWithReference.tipo || ''
        })
      }

    case CHANGE_CONTENT:
      if (state.content.tipo !== action.content.tipo) {
        return {
          ...state,
          conteudoHtml: '',
          content: { ...initialState.content, tipo: action.content.tipo },
          contentFormTouched: false,
          contentFormErrors: ContentValidate.validate({
            formObject: { ...initialState.content, tipo: action.content.tipo },
            formSchemaType: action.content.tipo || ''
          })
        }
      }
      return {
        ...state,
        content: action.content,
        contentFormErrors: ContentValidate.validate({
          formObject: action.content,
          formSchemaType: action.content.tipo || ''
        })
      }
    case FETCH_HTML_PREVIEW:
      return {
        ...state,
        conteudoHtml: action.conteudoHtml,
        loadingHtmlPreview: false
      }
    case FETCHING_HTML_PREVIEW:
      return {
        ...state,
        loadingHtmlPreview: true
      }
    case CONTENT_FORM_ERROR:
      const formErrors = {}
      formErrors[action.field] = { valid: false, errorMessage: action.message }
      return {
        ...state,
        contentFormErrors: ContentValidate.validate({
          formObject: state.content,
          invalidFields: formErrors,
          formSchemaType: state.content.tipo || ''
        })
      }
    case NEW_FORM_CONTENT:
      return {
        ...state,
        content: { ...initialState.content },
        contentFormErrors: ContentValidate.validate({}),
        contentFormTouched: false
      }
    case FORM_TOUCHED:
      return {
        ...state,
        contentFormTouched: true
      }
    case REMOVE_CONTENT_DOCUMENT: {
      return {
        ...state,
        conteudoHtml: '',
        content: {
          ...state.content,
          document: ''
        }
      }
    }
    case CHANGE_ORDER_COLUMN:
      return {
        ...state,
        order: {
          direction: 1,
          column: action.column
        }
      }
    case CHANGE_ORDER_DIRECTION:
      return {
        ...state,
        order: {
          ...state.order,
          direction: action.direction
        }
      }
    case OPEN_MODAL:
      return {
        ...state,
        modalOpen: true
      }
    case CLOSE_MODAL:
      return {
        ...state,
        modalOpen: false
      }
    case CHANGE_PAGE:
      return {
        ...state,
        contentsPagination: {
          ...state.contentsPagination,
          page: action.page
        }
      }
    case CHANGE_PER_PAGE:
      return {
        ...state,
        contentsPagination: {
          ...state.contentsPagination,
          rowsPerPage: action.perPage
        }
      }
    case FETCH_CONTENT:
      return {
        ...state,
        content: action.content,
        loadingContent: false,
        fetchcontentError: false,
        contentFormTouched: false,
        contentFormErrors: ContentValidate.validate({
          formObject: action.content,
          formSchemaType: action.content.tipo || ''
        })
      }
    case FETCHING_CONTENT:
      return {
        ...state,
        loadingContent: true,
        fetchContentError: false
      }
    case DELETE_CONTENT:
      return {
        ...state,
        loadingContents: false,
        fetchContentError: false,
        contents: state.contents.map(content => {
          if (content._id === action.content._id) {
            return action.content
          }
          return content
        })
      }
    case FETCH_CONTENT_ERROR:
      return {
        ...state,
        loadingContent: false,
        content: { ...initialState.content },
        fetchContentError: action.error
      }
    case FETCH_CONTENTS:
      return {
        ...state,
        loadingContents: false,
        contents: action.contents,
        fetchContentsError: false,
        order: action.order,
        contentsPagination: {
          length: action.length,
          page: action.page,
          rowsPerPage: action.rowsPerPage
        }
      }
    case FETCH_HTML_PREVIEW_ERROR:
      return {
        ...state,
        conteudoHtml: '',
        loadingHtmlPreview: false
      }
    case EDIT_CONTENT:
      return {
        ...state,
        contents: state.contents.map(content => {
          if (content._id === action.content._id) {
            return action.content
          }
          return content
        }),
        loadingContents: false,
        fetchContentError: false,
        loadingContent: false,
        fetchContentsError: false
      }
    case FETCHING_CONTENTS:
      return {
        ...state,
        loadingContents: true,
        fetchContentsError: false
      }
    case FETCH_CONTENTS_ERROR:
      return {
        ...state,
        loadingContents: false,
        fetchContentError: action.error,
        loadingContent: false
      }
    case ADD_CONTENT:
      return {
        ...state,
        loadingContents: false,
        fetchContentError: false,
        loadingContent: false,
        contents: [...state.contents, action.content]
      }
    case FETCHING_LOGS:
      return {
        ...state,
        loadingLogs: true,
        fetchLogsError: false
      }
    case OPEN_LOGS_MODAL:
      return {
        ...state,
        openLogsModal: true
      }
    case CLOSE_LOGS_MODAL:
      return {
        ...state,
        openLogsModal: false
      }
    case FETCH_LOGS:
      return {
        ...state,
        fetchLogsError: false,
        logs: action.logs,
        loadingLogs: false
      }
    case FETCH_LOGS_ERROR:
      return {
        ...state,
        loadingLogs: false,
        fetchLogsError: action.error
      }
    case OPEN_EDIT_DOCUMENT_MODAL:
      return {
        ...state,
        openEditDocumentModal: true
      }
    case CLOSE_EDIT_DOCUMENT_MODAL:
      return {
        ...state,
        openEditDocumentModal: false
      }
    case CLEAR_BUSCA_PESO:
      return {
        ...state,
        buscaPeso: '',
        content: {
          ...state.content,
          buscaPeso: ''
        }
      }
    case RESET_STATE:
      return initialState
    case CHANGE_JOB_STATUS:
      return {
        ...state,
        jobStatus: action.jobStatus
      }
    default:
      return state
  }
}

export default contents



// WEBPACK FOOTER //
// ./src/reducers/content.js